(function(){
  'use strict';

  var CODE_KEY = 'paccoDiscountCode';
  var htmlEntityMap = {
    '&quot;': '"',
    '&apos;': "'",
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&'
  };

  function normalizeJsonString(raw){
    if (!raw) return '';
    var str = String(raw).trim();
    if (!str) return '';
    if (str.indexOf('&') !== -1) {
      str = str.replace(/&(?:quot|apos|lt|gt|amp);/g, function(entity){
        return htmlEntityMap[entity] || entity;
      });
    }
    return str;
  }

  function parseMeta(raw){
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    var normalized = normalizeJsonString(raw);
    if (!normalized || normalized === 'null' || normalized === 'undefined') return null;
    try{
      return JSON.parse(normalized);
    }catch(_){
      return null;
    }
  }

  function readPct(entry){
    if (entry == null) return 0;
    if (typeof entry === 'number') return entry > 0 ? entry : 0;
    if (typeof entry === 'string') {
      var numeric = Number(entry);
      return Number.isFinite ? (Number.isFinite(numeric) && numeric > 0 ? numeric : 0) : (isFinite(numeric) && numeric > 0 ? numeric : 0);
    }
    if (typeof entry === 'object') {
      var direct = entry.percentage != null ? entry.percentage : (entry.PERCENTAGE != null ? entry.PERCENTAGE : (entry.value != null ? entry.value : entry.VALUE));
      if (direct != null) {
        var numericDirect = Number(direct);
        return Number.isFinite ? (Number.isFinite(numericDirect) && numericDirect > 0 ? numericDirect : 0) : (isFinite(numericDirect) && numericDirect > 0 ? numericDirect : 0);
      }
    }
    return 0;
  }

  function readPctRecursive(entry){
    var direct = readPct(entry);
    if (direct) return direct;
    if (entry && typeof entry === 'object') {
      var fromDefault = readPctRecursive(entry.default || entry.DEFAULT);
      if (fromDefault) return fromDefault;
      var fromValue = readPctRecursive(entry.value || entry.VALUE);
      if (fromValue) return fromValue;
    }
    return 0;
  }

  function getAutomaticPct(meta, variantId){
    if (!meta || typeof meta !== 'object') return 0;
    var automatic = meta.automatic || meta.AUTOMATIC;
    if (!automatic) return 0;

    var variantsMap = automatic.variants || automatic.VARIANTS;
    if (variantsMap && variantId) {
      var keys = [
        String(variantId),
        Number(variantId),
        'gid://shopify/ProductVariant/' + variantId
      ];
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (key == null) continue;
        if (variantsMap[key] != null) {
          var pctVariant = readPctRecursive(variantsMap[key]);
          if (pctVariant > 0) return pctVariant;
        }
      }
    }

    var pctDefault = readPctRecursive(automatic.default || automatic.DEFAULT);
    if (pctDefault > 0) return pctDefault;

    return readPctRecursive(automatic);
  }

  function getCodesPct(meta, code, variantId){
    if (!meta || typeof meta !== 'object' || !code) return 0;
    var codes = meta.codes || meta.CODES;
    if (!codes) return 0;
    var upperCode = code.toUpperCase();
    var entry = codes[upperCode] || codes[upperCode.toLowerCase()] || codes[upperCode.replace(/[^A-Z0-9_-]/gi, '')];
    if (!entry) return 0;

    var variantsMap = entry.variants || entry.VARIANTS;
    if (variantsMap && variantId) {
      var keys = [
        String(variantId),
        Number(variantId),
        'gid://shopify/ProductVariant/' + variantId
      ];
      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        if (key == null) continue;
        if (variantsMap[key] != null) {
          var pctVariant = readPctRecursive(variantsMap[key]);
          if (pctVariant > 0) return pctVariant;
        }
      }
    }

    var fallback = readPctRecursive(entry);
    return fallback > 0 ? fallback : 0;
  }

  function detectCode(){
    try{
      var url = new URL(window.location.href);
      var param = (url.searchParams.get('discount') || '').trim();
      if (param) return param.toUpperCase();
      var param2 = (url.searchParams.get('discount_code') || '').trim();
      if (param2) return param2.toUpperCase();
    }catch(_){ }

    var cookieMatch = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/i);
    if (cookieMatch && cookieMatch[1]) {
      try{
        return decodeURIComponent(cookieMatch[1]).trim().toUpperCase();
      }catch(_){
        return cookieMatch[1].trim().toUpperCase();
      }
    }

    try{
      var stored = localStorage.getItem(CODE_KEY);
      if (stored) return stored.trim().toUpperCase();
    }catch(_){ }

    return '';
  }

  function getConfig(){
    var cfg = window.__viCardConfig || {};
    return {
      moneyFormat: cfg.moneyFormat || '${{amount}}',
      minInstallment: Number(cfg.minInstallmentCents) || 0,
      maxInstallments: Number(cfg.maxInstallments) || 1
    };
  }

  var singleVariantGuard = false;
  function ensureSingleVariantGuard(){
    if(singleVariantGuard) return;
    singleVariantGuard = true;
    document.addEventListener('submit', function(ev){
      var form = ev.target && ev.target.closest ? ev.target.closest('.product-item__quick-form[data-vi-one-variant="1"]') : null;
      if (!form) return;
      var datasetVid = form.getAttribute('data-variant-id');
      var hiddenId   = form.querySelector('input[name="id"]');
      var vid = (datasetVid && /^\d+$/.test(datasetVid)) ? datasetVid : (hiddenId ? hiddenId.value : '');
      if (hiddenId && vid && hiddenId.value !== vid) {
        hiddenId.value = vid;
      }
    }, true);
  }

  function initCard(target){
    var root = typeof target === 'string' ? document.getElementById(target) : target;
    if(!root || root.dataset.viReady === '1') return;
    root.dataset.viReady = '1';
    ensureSingleVariantGuard();

    var config = getConfig();
    var moneyFormat = config.moneyFormat;
    var minInstall = config.minInstallment;
    var maxInstall = config.maxInstallments;
    var productTitle = root.dataset.productTitle || '';
    var cardUid = root.getAttribute('id') || '';

    function setupCarousel(carousel){
      var viewport = carousel.querySelector('.vi-viewport');
      var rail = carousel.querySelector('.vi-rail');
      if(!viewport || !rail) return;

      var prev = carousel.querySelector('[data-vi-prev]');
      var next = carousel.querySelector('[data-vi-next]');

      function update(){
        var overflow = viewport.scrollWidth > viewport.clientWidth + 2;
        if(prev && next){
          if(overflow){ prev.classList.add('is-visible'); next.classList.add('is-visible'); }
          else{ prev.classList.remove('is-visible'); next.classList.remove('is-visible'); }
        }
        var atStart = viewport.scrollLeft <= 0;
        var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
        if(prev) prev.disabled = atStart;
        if(next) next.disabled = atEnd;
      }

      function step(dir){
        var item = rail.firstElementChild;
        var gap = 6;
        try{
          var cs = getComputedStyle(rail);
          gap = parseInt(cs.columnGap || cs.gap, 10) || 6;
        }catch(_){ }
        var delta = (item ? item.offsetWidth : 24) + gap;
        var visible = Math.max(1, Math.floor(viewport.clientWidth / delta));
        viewport.scrollBy({ left: dir * delta * visible, behavior: 'smooth' });
      }
      prev && prev.addEventListener('click', function(){ step(-1); });
      next && next.addEventListener('click', function(){ step(1); });
      viewport.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
      carousel.dataset.viBound = '1';
    }

    root.querySelectorAll('.vi-carousel').forEach(setupCarousel);

    (function initLayers(){
      var box = root.querySelector('.vi-imgbox');
      if(!box) return;
      if(box.querySelector('.vi-layer')) return;
      var l1 = document.createElement('div'); l1.className = 'vi-layer is-active';
      var l2 = document.createElement('div'); l2.className = 'vi-layer';
      while(box.firstChild){ l1.appendChild(box.firstChild); }
      box.appendChild(l1); box.appendChild(l2);
    })();

    (function initOverlay(){
      var box = root.querySelector('.vi-imgbox');
      var labels = root.querySelector('.vi-labels');
      if(!box || !labels) return;
      try{
        if(getComputedStyle(box).position === 'static'){ box.style.position = 'relative'; }
      }catch(_){ box.style.position = 'relative'; }
      var ov = box.querySelector('.vi-overlay');
      if(!ov){
        ov = document.createElement('div');
        ov.className = 'vi-overlay';
        ov.style.position = 'absolute';
        ov.style.inset = '0';
        ov.style.pointerEvents = 'none';
        ov.style.zIndex = '3';
        box.appendChild(ov);
      }
      labels.style.position = 'absolute';
      labels.style.left = '8px';
      labels.style.top  = '8px';
      labels.style.zIndex = '10';
      labels.style.pointerEvents = 'none';
      ov.appendChild(labels);
    })();

    function createImg(src, cls, altText){
      if(!src) return null;
      var img = new Image();
      img.decoding = 'async';
      img.loading = 'eager';
      img.fetchPriority = 'high';
      img.className = cls;
      img.alt = altText || productTitle || '';
      img.src = src;
      return img;
    }

    function preloadVideoElement(src){
      if(!src) return null;
      var v = document.createElement('video');
      v.preload = 'metadata';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.autoplay = true;
      v.setAttribute('muted','');
      v.setAttribute('loop','');
      v.setAttribute('playsinline','');
      v.setAttribute('autoplay','');
      var s = document.createElement('source');
      s.src = src;
      s.type = 'video/mp4';
      v.appendChild(s);
      return v;
    }

    function showBusy(on){
      var box = root.querySelector('.vi-imgbox');
      if(!box) return;
      var busy = box.querySelector('.vi-busy');
      if(on){
        if(!busy){
          busy = document.createElement('div');
          busy.className = 'vi-busy';
          box.appendChild(busy);
        }
      }else if(busy){
        busy.remove();
      }
    }

    function swapMedia(data){
      var box = root.querySelector('.vi-imgbox');
      if(!box) return;
      var active = box.querySelector('.vi-layer.is-active');
      var layers = box.querySelectorAll('.vi-layer');
      var idle = (layers[0] === active) ? layers[1] : layers[0];
      idle.textContent = '';
      showBusy(true);
      var waits = [];
      var videoEl = null;
      if(data.video){
        var v = preloadVideoElement(data.video);
        if(v){
          idle.appendChild(v);
          videoEl = v;
          if(v.readyState < 2){
            waits.push(new Promise(function(res){ v.addEventListener('loadeddata', res, {once:true}); }));
          }
          v.addEventListener('loadeddata', function handleLoaded(){
            v.removeEventListener('loadeddata', handleLoaded);
            var playPromise = v.play && v.play();
            if(playPromise && typeof playPromise.catch === 'function'){ playPromise.catch(function(){}); }
          }, {once:true});
        }
        if(data.secondary){
          var img2 = createImg(data.secondary, 'vi-img vi-img--secondary');
          if(img2){
            idle.appendChild(img2);
            if(img2.decode){
              waits.push(img2.decode().catch(function(){}));
            }else{
              waits.push(new Promise(function(resolve){ img2.addEventListener('load', resolve, {once:true}); }));
            }
          }
        }
      } else if(data.primary || data.secondary){
        var img1 = createImg(data.primary || data.secondary, 'vi-img vi-img--primary');
        if(img1){
          idle.appendChild(img1);
          if(img1.decode){
            waits.push(img1.decode().catch(function(){}));
          }else{
            waits.push(new Promise(function(resolve){ img1.addEventListener('load', resolve, {once:true}); }));
          }
        }
        if(data.secondary && data.primary){
          var imgExtra = createImg(data.secondary, 'vi-img vi-img--secondary');
          if(imgExtra){
            idle.appendChild(imgExtra);
            if(imgExtra.decode){
              waits.push(imgExtra.decode().catch(function(){}));
            }else{
              waits.push(new Promise(function(resolve){ imgExtra.addEventListener('load', resolve, {once:true}); }));
            }
          }
        }
      }
      Promise.allSettled(waits).then(function(){
        showBusy(false);
        if(active){ active.classList.remove('is-active'); }
        if(idle){ idle.classList.add('is-active'); }
        if(videoEl){
          var playPromise = videoEl.play && videoEl.play();
          if(playPromise && typeof playPromise.catch === 'function'){ playPromise.catch(function(){}); }
        }
      }).catch(function(){ showBusy(false); });
    }

    function updateLabels(isAvailable){
      var labels = root.querySelector('.vi-labels');
      if(!labels) return;
      var tplId = cardUid ? (cardUid + '-labels-' + (isAvailable ? 'avail' : 'oos')) : '';
      var tpl = tplId ? document.getElementById(tplId) : null;
      if (tpl && tpl.innerHTML != null){
        labels.innerHTML = tpl.innerHTML.trim();
      } else {
        var avm = labels.querySelector('[data-label="avm"]');
        if (isAvailable) {
          avm && avm.remove();
        } else if (!avm) {
          var span = document.createElement('span');
          span.className = 'label label--highlight';
          span.setAttribute('data-label','avm');
          span.textContent = 'Avise-me';
          labels.prepend(span);
        }
      }
      var hasText = (labels.textContent || '').trim().length > 0;
      labels.classList.toggle('is-empty', !hasText);
    }

    function updateSeals(data){
      var wrap = root.querySelector('.product-item__image-wrapper');
      if(!wrap) return;
      var selectors = [
        '.product-item__selo-direita-superior',
        '.product-item__selo-direita-inferior',
        '.product-item__selo-esquerda-superior',
        '.product-item__selo-esquerda-inferior'
      ];
      if(!data || !data.avail){
        selectors.forEach(function(selector){
          var el = wrap.querySelector(selector);
          if(el) el.style.display = 'none';
        });
        return;
      }
      function setSelo(selector, url){
        var el = wrap.querySelector(selector);
        if(url){
          if(!el){
            el = document.createElement('div');
            el.className = selector.slice(1);
            var img = document.createElement('img');
            img.loading = 'lazy';
            img.alt = productTitle || 'Selo';
            el.appendChild(img);
            wrap.appendChild(el);
          }
          var imgTag = el.querySelector('img') || document.createElement('img');
          imgTag.src = url;
          if(!imgTag.parentNode) el.appendChild(imgTag);
          imgTag.alt = productTitle || 'Selo';
          el.style.display = '';
        }else if(el){
          el.style.display = 'none';
        }
      }
      setSelo(selectors[0], data.selo_ds);
      setSelo(selectors[1], data.selo_di);
      setSelo(selectors[2], data.selo_es);
      setSelo(selectors[3], data.selo_ei);
    }

    function fmt(cents){
      try{
        if(window.Shopify && typeof Shopify.formatMoney === 'function'){
          return Shopify.formatMoney(cents, moneyFormat);
        }
      }catch(_){ }
      var value = Number(cents || 0) / 100;
      return 'R$ ' + value.toFixed(2).replace('.', ',');
    }

    function updateCTA(isAvailable){
      root.classList.toggle('is-oos', !isAvailable);
    }

    (function bindCtaPersonalizeFlag(){
      var ctas = root.querySelectorAll('[data-vi-cta]');
      ctas.forEach(function(btn){
        btn.addEventListener('click', function(){
          var cta = (btn.getAttribute('data-vi-cta')||'');
          var isAvm = cta.indexOf('avm-') === 0;
          var availableNow = !root.classList.contains('is-oos');
          var flag = isAvm ? true : !availableNow;
          window.__personalizeDisabled = !!flag;
          if(flag){
            document.documentElement.setAttribute('data-disable-personalize','true');
          }else{
            document.documentElement.removeAttribute('data-disable-personalize');
          }
        }, {capture:true});
      });
    })();

    function applySelection(data, btn){
      if(btn){
        var rail = btn.closest('.vi-rail');
        if(rail){
          rail.querySelectorAll('.is-active').forEach(function(el){ el.classList.remove('is-active'); });
          btn.classList.add('is-active');
        }
      }
      swapMedia(data);
      var priceCents = Number(data.price);
      if (!Number.isFinite(priceCents)) priceCents = 0;
      var compareCents = Number(data.compare);
      if (!Number.isFinite(compareCents)) compareCents = 0;
      var discountPrice = parseInt(data.discountPrice || data.discount_price || '0', 10) || 0;
      var discountScope = data.discountSource || data.discount_scope || '';
      var variantId = data.vid;
      var targetVariantRaw = 'targetVariant' in data ? (data.targetVariant || '') : '';
      var targetProductRaw = 'targetProduct' in data ? (data.targetProduct || '') : '';
      var metaVariant = parseMeta(targetVariantRaw);
      var metaProduct = parseMeta(targetProductRaw);
      var autoVariant = getAutomaticPct(metaVariant, variantId);
      var autoProduct = getAutomaticPct(metaProduct, variantId);
      var activeCode = detectCode();
      var codeActive = !!activeCode;
      var codeProduct = codeActive ? getCodesPct(metaProduct, activeCode, variantId) : 0;
      var codeVariant = codeActive ? getCodesPct(metaVariant, activeCode, variantId) : 0;

      var fallbackRootPrice = parseInt(root.dataset.priceCents || root.getAttribute('data-price-cents') || '0', 10) || 0;
      var baseCents = priceCents || fallbackRootPrice || compareCents;
      var compareBase = compareCents > baseCents ? compareCents : 0;
      if (!compareBase && fallbackRootPrice > baseCents) {
        compareBase = fallbackRootPrice;
      }

      var pct = 0;
      var source = '';
      var currentCents = baseCents;

      if (discountPrice > 0) {
        if (baseCents > 0 && discountPrice > baseCents) {
          var dpScale = discountPrice;
          for (var i = 0; i < 6 && dpScale > baseCents && dpScale % 10 === 0; i += 1) {
            dpScale = Math.floor(dpScale / 10);
          }
          discountPrice = dpScale;
        }
        currentCents = discountPrice;
        if (!compareBase || compareBase <= currentCents) {
          compareBase = baseCents || compareCents || fallbackRootPrice || currentCents;
        }
        source = (discountScope ? discountScope + '-' : '') + 'discount-pricing';
      } else {
        if (autoVariant > 0) {
          pct = autoVariant;
          source = 'variant-auto';
        } else if (codeActive && codeVariant > 0) {
          pct = codeVariant;
          source = 'variant-code';
        } else if (autoProduct > 0) {
          pct = autoProduct;
          source = 'product-auto';
        } else if (codeActive && codeProduct > 0) {
          pct = codeProduct;
          source = 'product-code';
        }

        if (pct > 0 && baseCents > 0) {
          var off = Math.round(baseCents * (pct / 100));
          currentCents = Math.max(0, baseCents - off);
          compareBase = Math.max(compareBase, baseCents);
        }
      }


      if (source) {
        root.dataset.discountSource = source;
      } else {
        delete root.dataset.discountSource;
      }
      if (data.vid) {
        root.setAttribute('data-variant-id', data.vid);
        root.dataset.variantId = String(data.vid);
      }
      if ('targetVariant' in data) {
        var variantMeta = data.targetVariant || '';
        root.setAttribute('data-target-descontos', variantMeta);
        root.setAttribute('data-target-descontos-variant', variantMeta);
      }
      if ('targetProduct' in data) {
        var productMeta = data.targetProduct || '';
        root.setAttribute('data-target-descontos-product', productMeta);
      }

      if (baseCents > 0) {
        root.dataset.priceCents = String(baseCents);
        root.setAttribute('data-price-cents', String(baseCents));
      }
      if (discountPrice > 0) {
        root.dataset.discountPrice = String(discountPrice);
        root.setAttribute('data-discount-price', String(discountPrice));
        if (discountScope) {
          root.setAttribute('data-discount-price-scope', discountScope);
        } else {
          root.removeAttribute('data-discount-price-scope');
        }
      } else {
        delete root.dataset.discountPrice;
        root.removeAttribute('data-discount-price');
        root.removeAttribute('data-discount-price-scope');
      }
      root.dataset.origPrice = String(baseCents);
      root.setAttribute('data-orig-price', String(baseCents));
      if (compareBase > 0) {
        root.dataset.origCompare = String(compareBase);
      } else {
        delete root.dataset.origCompare;
      }
      var nowEl = root.querySelector('.vi-now');
      if(nowEl){
        var baseStr = String(baseCents);
        nowEl.dataset.amount = String(currentCents);
        nowEl.dataset.origAmount = baseStr;
        nowEl.dataset.originalAmount = baseStr;
        nowEl.dataset.origText = fmt(baseCents);
        nowEl.textContent = fmt(currentCents);
      }
      var wasEl = root.querySelector('.vi-was');
      if(wasEl){
        if(compareBase > currentCents){
          var compareStr = String(compareBase);
          wasEl.dataset.amount = compareStr;
          wasEl.dataset.origAmount = compareStr;
          wasEl.dataset.originalAmount = compareStr;
          wasEl.dataset.origText = fmt(compareBase);
          wasEl.textContent = fmt(compareBase);
          wasEl.style.display = '';
        } else {
          delete wasEl.dataset.amount;
          delete wasEl.dataset.origAmount;
          delete wasEl.dataset.originalAmount;
          delete wasEl.dataset.origText;
          wasEl.textContent = '';
          wasEl.style.display = 'none';
        }
      }
      var instEl = root.querySelector('.vi-install');
      if(instEl){
        var n = minInstall > 0 ? Math.floor(currentCents / minInstall) : 0;
        if(n > maxInstall) n = maxInstall;
        if(n < 1) n = 1;
        if(n > 1){
          var per = Math.round(currentCents/n);
          instEl.textContent = 'ou em até ' + n + 'x ' + fmt(per) + ' sem juros';
        } else {
          instEl.textContent = '';
        }
        instEl.dataset.origText = instEl.textContent || '';
      }
      var input = root.querySelector('[data-vi-variant-input]'); 
      if(input) input.value = data.vid;
      var imgLink = root.querySelector('.vi-card__img'); 
      if(imgLink) imgLink.setAttribute('href', data.vurl);
      var titleLink = root.querySelector('.vi-card__title'); 
      if(titleLink) titleLink.setAttribute('href', data.vurl);
      var pop = root.querySelector('quick-buy-popover'); 
      if(pop) pop.setAttribute('href', data.vurl);
      var drw = root.querySelector('quick-buy-drawer'); 
      if(drw) drw.setAttribute('href', data.vurl);
      updateLabels(!!data.avail);
      updateSeals(data);
      updateCTA(!!data.avail);
    }

    function handleVariantTrigger(target){
      var btn = target.closest ? target.closest('[data-vi-select]') : null;
      if(!btn) return;
      var data = {
        vid: btn.getAttribute('data-vid'),
        vurl: btn.getAttribute('data-vurl'),
        price: parseInt(btn.getAttribute('data-price'), 10) || 0,
        compare: parseInt(btn.getAttribute('data-compare'), 10) || 0,
        discountPrice: parseInt(btn.getAttribute('data-discount-price'), 10) || 0,
        discountSource: btn.getAttribute('data-discount-source') || '',
        primary: btn.getAttribute('data-primary') || '',
        secondary: btn.getAttribute('data-secondary') || '',
        video: btn.getAttribute('data-video') || '',
        avail: btn.getAttribute('data-avail') === '1',
        selo_ds: btn.getAttribute('data-selo-ds') || '',
        selo_di: btn.getAttribute('data-selo-di') || '',
        selo_es: btn.getAttribute('data-selo-es') || '',
        selo_ei: btn.getAttribute('data-selo-ei') || '',
        targetVariant: btn.getAttribute('data-target-descontos-variant') || '',
        targetProduct: btn.getAttribute('data-target-descontos-product') || ''
      };
      applySelection(data, btn);
    }

    root.addEventListener('pointerdown', function(e){ handleVariantTrigger(e.target); }, {passive:true});
    root.addEventListener('click', function(e){
      if(e.target && e.target.closest && e.target.closest('[data-vi-select]')) e.preventDefault();
    });

      var initialBtn = root.querySelector('[data-vi-select].is-active') || root.querySelector('[data-vi-select]');
      if (initialBtn) {
        handleVariantTrigger(initialBtn);
      } else if (!root.querySelector('[data-vi-select]')) {
        var variantId = parseInt(root.getAttribute('data-variant-id'), 10) || 0;
        var basePrice = parseInt(root.getAttribute('data-orig-price'), 10) || parseInt(root.dataset.origPrice || root.dataset.priceCents || '0', 10) || 0;
        var discountPrice = parseInt(root.getAttribute('data-discount-price') || root.dataset.discountPrice || '0', 10) || 0;
        var discountScope = root.getAttribute('data-discount-price-scope') || root.dataset.discountPriceScope || '';
        var metaVariantRaw = root.getAttribute('data-target-descontos-variant') || '';
        var metaProductRaw = root.getAttribute('data-target-descontos-product') || '';
        var metaVariant = parseMeta(metaVariantRaw);
        var metaProduct = parseMeta(metaProductRaw);
        var activeCode = detectCode();
        var automaticVariant = getAutomaticPct(metaVariant, variantId);
        var automaticProduct = getAutomaticPct(metaProduct, variantId);
        var codeVariant = activeCode ? getCodesPct(metaVariant, activeCode, variantId) : 0;
        var codeProduct = activeCode ? getCodesPct(metaProduct, activeCode, variantId) : 0;
        var pct = 0;
        if (automaticVariant > 0) {
          pct = automaticVariant;
        } else if (codeVariant > 0) {
          pct = codeVariant;
        } else if (automaticProduct > 0) {
          pct = automaticProduct;
        } else if (codeProduct > 0) {
          pct = codeProduct;
        }
        if (basePrice > 0 && (discountPrice > 0 || pct > 0)) {
          if (discountPrice > basePrice) {
            var dpScale = discountPrice;
            for (var i2 = 0; i2 < 6 && dpScale > basePrice && dpScale % 10 === 0; i2 += 1) {
              dpScale = Math.floor(dpScale / 10);
            }
            discountPrice = dpScale;
          }
          var discounted = discountPrice > 0 ? discountPrice : Math.max(0, basePrice - Math.round(basePrice * (pct / 100)));
          var imgLinkEl = root.querySelector('.vi-card__img');
          var href = imgLinkEl ? imgLinkEl.getAttribute('href') : '';
          var wrapEl = root.querySelector('.product-item__image-wrapper');
          function readSelo(selector){
            if(!wrapEl) return '';
            var img = wrapEl.querySelector(selector + ' img');
            return img ? img.getAttribute('src') : '';
          }
          var compareVal = basePrice;
          if (compareVal <= discounted) {
            compareVal = parseInt(root.getAttribute('data-orig-compare'), 10) || basePrice;
          }
          var payload = {
            vid: variantId,
            vurl: href || '',
            price: discounted,
            compare: compareVal,
            primary: '',
            secondary: '',
            video: '',
            avail: root.getAttribute('data-available') === 'true',
            selo_ds: readSelo('.product-item__selo-direita-superior'),
            selo_di: readSelo('.product-item__selo-direita-inferior'),
            selo_es: readSelo('.product-item__selo-esquerda-superior'),
            selo_ei: readSelo('.product-item__selo-esquerda-inferior'),
            targetVariant: metaVariantRaw,
            targetProduct: metaProductRaw,
            discountPrice: discountPrice,
            discountSource: discountPrice > 0 ? discountScope : ''
          };
          applySelection(payload, null);
        }
      }
  }

  function runInlineVariantScripts(scope){
    var ctx = scope && scope.querySelectorAll ? scope : document;
    if(!ctx || !ctx.querySelectorAll) return;
    ctx.querySelectorAll('script[data-vi-inline]').forEach(function(script){
      if(!script || script.dataset.viExecuted === '1') return;
      var typeAttr = (script.getAttribute('type') || '').trim();
      if(typeAttr && typeAttr !== 'text/javascript' && typeAttr !== 'application/javascript' && typeAttr !== 'module'){
        return;
      }
      var parent = script.parentNode;
      if(!parent) return;
      var cardRoot = script.closest ? script.closest('variant-item') : null;
      if(cardRoot){
        delete cardRoot.dataset.viReady;
        cardRoot.removeAttribute('data-vi-ready');
      }
      var clone = document.createElement('script');
      if(typeAttr) clone.type = typeAttr;
      if(script.hasAttribute('nonce')){
        clone.setAttribute('nonce', script.getAttribute('nonce'));
      }
      clone.textContent = script.textContent;
      clone.dataset.viInline = script.getAttribute('data-vi-inline') || '';
      clone.dataset.viExecuted = '1';
      parent.replaceChild(clone, script);
    });
  }

  function initWithin(scope){
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var nodes = ctx.querySelectorAll ? ctx.querySelectorAll('variant-item[id]') : [];
    nodes.forEach(function(node){ initCard(node); });
  }

  function drainQueue(){
    var queue = window.__viCardQueue;
    if(!Array.isArray(queue) || !queue.length) return;
    while(queue.length){
      var id = queue.shift();
      initCard(id);
    }
  }

  function overridePush(){
    var queue = window.__viCardQueue;
    if(!Array.isArray(queue)){
      queue = [];
      window.__viCardQueue = queue;
    }
    var nativePush = queue.push;
    if(queue.__viWrapped) return;
    queue.__viWrapped = true;
    queue.push = function(){
      var res = Array.prototype.push.apply(queue, arguments);
      drainQueue();
      return res;
    };
  }

  window.__viInitCard = initCard;
  window.__viInitAll = function(scope){
    initWithin(scope || document);
    drainQueue();
  };

  window.__viRunVariantScripts = function(scope){
    var target = scope && scope.querySelectorAll ? scope : document;
    runInlineVariantScripts(target);
    if(window.__viInitAll){
      window.__viInitAll(target);
    }else{
      initWithin(target);
      drainQueue();
    }
  };

  function handleScopeEvent(event){
    var scope = null;
    if(event){
      if(event.detail && event.detail.scope){ scope = event.detail.scope; }
      else if(event.detail && event.detail.container){ scope = event.detail.container; }
      else if(event.target instanceof Element){ scope = event.target; }
    }
    initWithin(scope || document);
    drainQueue();
  }

  document.addEventListener('collection:items:added', handleScopeEvent);
  document.addEventListener('search:items:added', handleScopeEvent);
  document.addEventListener('facets:updated', handleScopeEvent);
  document.addEventListener('shopify:section:load', handleScopeEvent);

  if(window.MutationObserver){
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        record.addedNodes && record.addedNodes.forEach(function(node){
          if(!node || node.nodeType !== 1) return;
          if(node.matches && node.matches('variant-item')){
            initCard(node);
          }else if(node.querySelectorAll){
            node.querySelectorAll('variant-item').forEach(function(child){ initCard(child); });
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initWithin(document);
    drainQueue();
  });

  overridePush();
  drainQueue();
  initWithin(document);
})();
